import React from 'react'
import { Icon, Text } from 'components'
import noop from 'lib/noop'
import styles from './OpenSimulator.module.scss'

const OpenSimulator = ({ show = true, onClick = noop }) =>
  show && (
    <span className={styles.openSimulator}>
      <span className={styles.indicator}>
        <Icon type="hand" size={26} color="darkColor" />{' '}
        <Text>Quer parcelar este imóvel?</Text>
      </span>
      <button type="button" className={styles.button} onClick={onClick}>
        <Text className={styles.simulatorText}>Simule aqui</Text>
      </button>
    </span>
  )

export default React.memo(OpenSimulator)
